module.exports = __webpack_public_path__ + "static/media/singapore-post.9e1b1a45.svg";